import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import CBMediaQuery from '../../shared/CBMediaQuery';
import { getStyle } from '../../../utils/utils';
import CBInputField from '../../shared/form_components/CBInputField';
import {
  addChainCareServiceVehicle as _addChainCareServiceVehicle,
} from '../../../actions/chainActions';
import {
  getRegistrationNumberValidator,
} from '../../../utils/validators';
import CBModal from '../../shared/CBModal';
import CBSelectField from '../../shared/form_components/CBSelectField';
import EquipmentCareServiceSearch from '../../shared/EquipmentCareServiceSearch';
import {
  REGISTRATION_COUNTRY_FI,
  REGISTRATION_COUNTRY_UNREGISTERED,
  getRegistrationCountryOptions,
} from '../../../utils/equipment';

class AddChainCareServiceVehicleModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        registration_number: '',
      },
      formValid: {
        registration_number: false,
      },
      // 'UNREGISTERED' finds a customer's existing machine by its identifier
      // instead of asking Traficom for a plate.
      registrationCountry: REGISTRATION_COUNTRY_FI,
      equipmentVehicleId: null,
    };
  }

  isUnregistered = () => this.state.registrationCountry === REGISTRATION_COUNTRY_UNREGISTERED;

  setIsValid = (name, isValid) => {
    const { formValid } = this.state;
    this.setState({
      formValid: { ...formValid, [name]: isValid },
    });
  };

  getIsValid = () => {
    const { formValid, equipmentVehicleId } = this.state;
    if (this.isUnregistered()) {
      return !!equipmentVehicleId;
    }
    return formValid.registration_number;
  };

  updateFormState = changedObject => {
    const { formData } = this.state;
    this.setState({
      formData: { ...formData, [changedObject.target]: changedObject.value },
    });
  };

  submitForm = () => {
    const { formData } = this.state;
    const { closeModal, addChainCareServiceVehicle, chainId, onVehicleAdded } = this.props;

    addChainCareServiceVehicle(this.isUnregistered()
      ? {
        chain_id: chainId,
        registration_country: REGISTRATION_COUNTRY_UNREGISTERED,
        vehicle_id: this.state.equipmentVehicleId,
      }
      : {
        chain_id: chainId,
        registration_number: formData.registration_number,
      });

    closeModal();

    // Refetch vehicle list after a short delay to allow the backend to process
    if (onVehicleAdded) {
      setTimeout(onVehicleAdded, 1000);
    }
  };

  render() {
    const { formData } = this.state;
    const {
      modalIsOpen,
      closeModal,
      t,
    } = this.props;

    return (
      <CBMediaQuery>
        {screenSize => (
          <CBModal
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            title={t('addVehicleToCareServiceTitle')}
            descriptionText={t('addVehicleToCareServiceDescription')}
            cancelText={t('cancel')}
            submitText={t('addVehicle')}
            submitForm={this.submitForm}
            isValid={this.getIsValid()}
          >
            <div style={getStyle(screenSize, styles, 'bodyContainer')}>
              <CBSelectField
                name='registrationCountry'
                labelText={t('registrationCountryHeading', { ns: 'GarageView' })}
                labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                inputStyle={getStyle(screenSize, styles, 'input')}
                value={this.state.registrationCountry}
                options={getRegistrationCountryOptions((key) => t(key, { ns: 'GarageView' }))}
                onChange={(changed) => this.setState({ registrationCountry: changed.value, equipmentVehicleId: null })}
              />
              {
                this.isUnregistered() && (
                  <EquipmentCareServiceSearch
                    candidatesUrl='/uiapi/1/chain_care_service_vehicle/equipment_candidates/'
                    params={{ chain_id: this.props.chainId }}
                    onSelect={(vehicleId) => this.setState({ equipmentVehicleId: vehicleId })}
                    inputStyle={getStyle(screenSize, styles, 'input')}
                    labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
                  />
                )
              }
              {
                !this.isUnregistered() && (
              <CBInputField
                name='registration_number'
                inputStyle={getStyle(screenSize, styles, 'input')}
                value={formData.registration_number.toUpperCase()}
                placeholder={t('regNroPlaceHolder')}
                onChange={this.updateFormState}
                validators={[getRegistrationNumberValidator()]}
                isValidCallback={this.setIsValid}
                labelText={t('registrationNumberLabel')}
                labelTextStyle={getStyle(screenSize, styles, 'inputLabelText')}
              />
                )
              }
              <p style={getStyle(screenSize, styles, 'infoText')}>
                {t('addVehicleToCareServiceInfo')}
              </p>
            </div>
          </CBModal>
        )}
      </CBMediaQuery>
    );
  }
}

const styles = {
  default: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 32px',
    },
    input: {
      backgroundColor: '#ebebeb',
      fontSize: 14,
      textAlign: 'center',
      resize: 'none',
      color: 'black',
      borderRadius: 100,
      height: 40,
      border: 'none',
      width: '100%',
    },
    inputLabelText: {
      color: 'black',
    },
    infoText: {
      fontSize: 13,
      color: '#666',
      marginTop: 12,
    },
  },
  small: {
    bodyContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '16px 16px',
    },
  },
};

function mapStateToProps() {
  return {};
}

export default connect(
  mapStateToProps,
  {
    addChainCareServiceVehicle: _addChainCareServiceVehicle,
  },
)(translate('ChainCareService')(AddChainCareServiceVehicleModal));
